import { FC } from "react";

import {
  NOTIFICATION_ACTION_TYPES,
  createNotificationAction,
} from "shared/ui/notifications/notification-generic/base-parts/actions";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { safeGetDate } from "shared/lib/helpers";
import { DATE_FORMAT } from "shared/lib/constants/time";
import { EMAIL_INBOX_TYPES } from "shared/lib/constants/email-inbox";

import { NotificationBase } from "@/modules/notifications/notification/base";
import { NotificationI } from "@/lib/types/notification";
import Router from "@/helpers/router";

type NotificationCalendarInviteReceivedPropsI = NotificationI &
  PropsWithClassNameI;

/**
 * One notification per meeting (GLE-8154): a reschedule re-surfaces this row
 * rather than adding another, so the copy has to read correctly for both a new
 * invite and an updated one. A cancellation is not shown here at all — it
 * arrives as its own "Meeting canceled" notification.
 */
export const NotificationCalendarInviteReceived: FC<
  NotificationCalendarInviteReceivedPropsI
> = (props) => {
  const {
    id,
    thread_id,
    contact_name,
    campaign_name,
    meeting_start_time,

    is_seen,
    created_at,
    className,
  } = props;

  // Absent until the ICS pipeline has created the booking, which is a moment
  // after the invite is filed.
  const meetingTime = meeting_start_time
    ? safeGetDate(meeting_start_time, DATE_FORMAT)
    : undefined;

  return (
    <NotificationBase
      id={id}
      isUnread={!is_seen}
      className={className}
      avatar={props}
      description={{
        text: (
          <>
            A calendar invite for your meeting with{" "}
            <b>{contact_name || "your prospect"}</b> landed in your inbox
            {meetingTime ? <>, {meetingTime}</> : null}
          </>
        ),
        date: created_at,
        campaignName: campaign_name,
      }}
      actions={[
        createNotificationAction(
          NOTIFICATION_ACTION_TYPES.PRIMARY,
          "View invite",
          () => {
            window.location.href = Router.emailInbox({
              inboxType: EMAIL_INBOX_TYPES.CALENDAR,
              threadId: thread_id,
            });
          }
        ),
      ]}
    />
  );
};
